export const FeedbackSceneTranslation = {
  fi: {
    FeedbackScene: {
      title: 'Anna palautetta',
      text: 'Alla olevan kaavakkeen kautta voit jättää meille palautetta.',
      send: 'Lähetä',
    },
  },
};
